import { useQuery } from "@tanstack/react-query";
import { fetchGlobalVotes, type EpochVotesWithPercentages } from "@/services";
import { QUERY_KEYS, QUERY_CONFIG } from "@/config";
import { getNextEpoch } from "@/utils/epoch";

export interface GlobalVotesStore {
    nextEpochVotes: EpochVotesWithPercentages | null;
    currentEpochVotes: EpochVotesWithPercentages | null;
    isLoading: boolean;
    error: Error | null;
}

export const useGlobalVotesStore = (): GlobalVotesStore => {
    const nextEpoch = getNextEpoch();
    const currentEpoch = nextEpoch - 1;

    const {
        data: nextEpochVotes,
        isLoading: isCurrentLoading,
        error: currentError,
    } = useQuery<EpochVotesWithPercentages>({
        queryKey: QUERY_KEYS.VOTES.GLOBAL(nextEpoch),
        queryFn: () => fetchGlobalVotes(nextEpoch),
        ...QUERY_CONFIG.VOTES,
    });

    const {
        data: currentEpochVotes,
        isLoading: isPreviousLoading,
        error: previousError,
    } = useQuery<EpochVotesWithPercentages>({
        queryKey: QUERY_KEYS.VOTES.GLOBAL(currentEpoch),
        queryFn: () => fetchGlobalVotes(currentEpoch),
        ...QUERY_CONFIG.VOTES,
    });

    return {
        nextEpochVotes: nextEpochVotes ?? null,
        currentEpochVotes: currentEpochVotes ?? null,
        isLoading: isCurrentLoading || isPreviousLoading,
        error: (currentError || previousError) as Error | null,
    };
};
